var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
};


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.frontpage = {
	init: function() {
		$('.box_newsheadlines .link').hover(function () {
			var $hover = $(this);
			var $prev = null;
			site.frontpage.clearBefore();
			$('.box_newsheadlines .link').each(function () {
				if ($(this).attr('id') == $hover.attr('id')) {
					if($prev) {
						$prev.addClass('before');
					}
					return;
				}
				$prev = $(this);
			})
		}).mouseleave(function () {
			site.frontpage.clearBefore();
		})
	},
	clearBefore: function() {
		$('.box_newsheadlines .link').removeClass('before');
	},
	extrasCaroselItem: function() {
		site.owl.init('.box_extras_newData .items', {
			margin: 30,
			dots: false,
			nav: true,
			navText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
			responsive: {
				0: {
					items: 2
				},
				768: {
					items: 3
				},
				992: {
					items: 4
				},
				1320: {
					items: 5
				}
			}
		})
	}
};

site.rightbox = {
	init: function () {
		site.rightbox.resize();
		$(window).resize(function () {
			site.rightbox.resize();
		})
	},
	resize: function () {
		var height = $('.top').height() + 80;
		var $bottom = $('.bottom');
		var $footer = $('#footerInfo');

		if($bottom.length > 0) {
			if ($(window).width() < 992) {
				$bottom.css('top', height + 'px');
				$footer.css('margin-top', height + 'px');
			} else {
				$bottom.attr('style', '');
				$footer.attr('style', '');
				var extra = 20;
				if ($('body').hasClass('loggedIn')) {
					extra += 31;
				}
				// $('.categoryNav').css('top', $('.top').outerHeight() + extra);
			}
		}
	}
};
site.inits.push('site.rightbox.init()');

site.highchartsAdmin = {
	english: function (options) {
		$('#modal-btn-en').on('click', function (e) {
			e.preventDefault();
		});

		highed.ready(function () {
			if (options) {
				highed.option('stickyChartProperties', options);
			}

			highed.ModalEditor('modal-btn-en', {
				allowDone: true,
				features: 'welcome import templates customize done',
				importer: {
					options: 'plugins csv json samples'
				}
			}, function (chart) {
				//on editor close
				var html = chart.export.html(false);
				highed.dom.get('htmlEn').value = html;
				$('#previewEn').html(html);

				var json = chart.toProject();
				highed.dom.get('projectEn').value = JSON.stringify(json);

			}, function (editor) {
				//on editor load
				var project = highed.dom.get('projectEn').value,
					project = (project) ? JSON.parse(project) : {};
				if (project.options) {
					editor.chart.loadProject(project);
					$('.highed-imp-pastearea').text(project.options.data.csv)

					var firstRow = (project.options.data.firstRowAsNames === true);
					$('input[type="checkbox"].highed-imp-input').attr('checked', firstRow);
				}
			});
		});
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
		site.frontpage.extrasCaroselItem();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
	site.megamenu.init();
});
